import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { getSuscribersWithOrgID } from '../../../../redux/actions/Suscriber'
// import { SearchBarAndFiltersSuscribers } from '../SearchAndFilters/SearchBarAndFilterSuscribers'
import TableHeader from './TableHeader/TableHeader'
import TableItem from './TableItem/TableItem'

import useStyles from './useStyles'

function SuscriberTable ({ id, rows, setRows, setLoading }) {
  const classes = useStyles()
  const dispatch = useDispatch()

  useEffect(async () => {
    setLoading(true)
    setRows(await dispatch(getSuscribersWithOrgID(id)))
    setLoading(false)
  }, [id])

  return (
    <>
      <div className={classes.root}>
        {/* <SearchBarAndFiltersSuscribers setRows={setRows} /> */}
        <div className={classes.tableWrap}>
          <table className={classes.table}>
            <TableHeader />
            <tbody className={classes.tableBody}>
              {rows &&
                rows.map((item, index) => (
                  <TableItem
                    listIndex={index}
                    key={item.subscriber_id}
                    item={item}
                    id={id}
                    setLoading={setLoading}
                  />
                ))}
            </tbody>
          </table>
        </div>
      </div>
    </>
  )
}
export default SuscriberTable
